// harmonized-shapes.component.ts
import { Component, OnDestroy, OnInit } from '@angular/core';
import { animate, style, transition, trigger, state } from '@angular/animations';
import { debounceTime, fromEvent, Subscription } from 'rxjs';

export interface Shape {
  path: string;
  state: string;
  name: string;
  startPosition: string;
  width?: string;
  height?: string;
}

@Component({
  selector: 'app-harmonized-shapes',
  templateUrl: './harmonized-shapes.component.html',
  styleUrls: ['./harmonized-shapes.component.scss'],
  animations: [
    trigger('slideAndBounce', [
      state(
        'initial',
        style({
          opacity: 0,
          transform: '{{startPosition}}',
        }),
        { params: { startPosition: 'translate(-100%, 0)' } },
      ),
      state(
        'final',
        style({
          opacity: 1,
          transform: 'translate(0, 0)',
        }),
      ),
      transition('initial => final', [animate('0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55)')]),
    ]),
  ],
  imports: [],
})
export class HarmonizedShapesComponent implements OnInit, OnDestroy {
  private resizeSubscription: Subscription;
  shapes: Shape[] = [
    {
      path: 'Harmonized_Shape_Circle_Orange_Gradient.svg',
      state: 'initial',
      name: 'Circle Arctic 1',
      startPosition: 'translate(100%, -50%)',
      // width: '375px',
      // height: '375px',
    },
    {
      path: 'Harmonized_Shape_Vertical_Pill_Arctic_Gradient.svg',
      state: 'initial',
      name: 'Vertical Pill Arctic 1',
      startPosition: 'translate(-100%, 0)',
      // width: '374px',
      // height: '746px',
    },
    {
      path: 'Harmonized_Shape_Horizontal_Pill_Arctic_Gradient.svg',
      state: 'initial',
      name: 'Horizonal Pill Orange 1',
      startPosition: 'translate(100%, 0)',
      // width: '746px',
      // height: '375px',
    },
    {
      path: 'Harmonized_Shape_Circle_Orange_Gradient.svg',
      state: 'initial',
      name: 'Circle Arctic 2',
      startPosition: 'translate(-100%, 50%)',
      // width: '375px',
      // height: '375px',
    },
    {
      path: 'Harmonized_Shape_Horizontal_Pill_Arctic_Gradient.svg',
      state: 'initial',
      name: 'Horizonal Pill Orange 1',
      startPosition: 'translate(100%, 0)',
      // width: '746px',
      // height: '375px',
    },
  ];

  ngOnInit(): void {
    setTimeout(() => this.startAnimations(), 100);
    // Handle window resize
    this.resizeSubscription = fromEvent(window, 'resize')
      .pipe(debounceTime(250))
      .subscribe(() => {
        // Reset and restart animations on major resize
        this.resetAndRestartAnimations();
      });
  }

  ngOnDestroy(): void {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }

  startAnimations(): void {
    this.shapes.forEach((shape, index) => {
      setTimeout(() => {
        shape.state = 'final';
      }, index * 300);
    });
  }

  resetAndRestartAnimations(): void {
    // Reset all shapes to initial state
    this.shapes.forEach((shape) => {
      shape.state = 'initial';
    });

    // Restart animations after a brief delay
    setTimeout(() => this.startAnimations(), 50);
  }

  onAnimationComplete(index: number): void {
    console.log(`Animation completed for shape ${index}`);
  }
}
